module.exports = __webpack_public_path__ + "static/img/342.026b8480.png";